<template>
  <div class="p-3 border dark:border-gray-800 rounded-lg flex items-center justify-between">
    <div class="flex items-center">
      <div class="md:block self-stretch relative pr-3">
        <div
          class="w-1 rounded h-full"
          :style="{
            backgroundColor: '#' + reservationService.service.borderHexColour
          }"
        />
      </div>
      <div>
        <p class="font-semibold">
          {{ $t('components.courseRun.elements.session.withEmployee', { service: reservationService.service.title, employee: reservation.employee.displayName }) }}
          <span class="font-normal">{{ $t('components.courseRun.elements.session.maxCustomers', { max: reservation.customerMax }) }}</span>
        </p>

        <p class="text-xm opacity-70">
          {{ reservation.dateLabel }}
        </p>

        <div class="flex items-center space-x-1">
          <o-chip v-if="isStatusCancelled" size="sm" variant="danger">
            {{ $t('general.cancelled') }}

            <span v-if="reservation.cancellationType">
              : {{ reservation.cancellationType.shortName }}
            </span>

            <span v-if="reservation.cancellationNote" class="ml-1">
              ({{ reservation.cancellationNote }})
            </span>
          </o-chip>
        </div>
      </div>
    </div>

    <div class="flex items-center space-x-1">
      <o-panel-link
        tag="o-button"
        size="sm"
        flat
        outline
        icon="edit"
        :path="`/appointment/${reservation.idReservation}?date=${reservation.date}`"
      />
      <o-button
        v-if="removable"
        icon="delete"
        size="sm"
        variant="danger"
        flat
        @click="$emit('remove', reservation)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  reservation: Record<string, any>
  removable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  removable: false,
})

const reservationService = computed(() => {
  return props.reservation.services[0]
})

const isStatusCancelled = computed(() => {
  return props.reservation.isStatusCancelled
})
</script>
